/**
 * Brand Configuration
 * Importa la configuración desde appConfig.json
 */
import appConfig from "./appConfig.json";

export const BRANDS = appConfig.brands;

/**
 * Get brand from URL path
 * Example: /ht -> returns "ht"
 * Example: /cc/dashboard -> returns "cc"
 */
export const getBrandFromUrl = () => {
  const pathname = window.location.pathname;
  const segments = pathname.split("/").filter((s) => s);
  const potentialBrand = segments[0];

  return BRANDS[potentialBrand] ? potentialBrand : appConfig.defaultBrand;
};

/**
 * Get brand configuration
 */
export const getBrandConfig = (brand) => {
  return BRANDS[brand] || BRANDS[appConfig.defaultBrand];
};

/**
 * Get API URL for the current brand
 */
export const getApiUrl = (brand) => {
  return getBrandConfig(brand).apiUrl;
};
